// Mock data for Acervo da Artesã sales landing page

export const galleryImages = [
  { src: "/site-images/2WMmiuGFbRzf.jpg", label: "Tags Premium" },
  { src: "/site-images/eNU0ydCoxzVW.jpg", label: "Sacolas Personalizadas" },
  { src: "/site-images/3Yzil1C4IsRu.jpg", label: "Caixas Prontas" },
  { src: "/site-images/WOnClYNa929Y.jpg", label: "Adesivos Exclusivos" },
  { src: "/site-images/3DaIfuK6r3S0.jpg", label: "Kits Escolares" },
  { src: "/site-images/UF1PqsxlFrIw.jpg", label: "Kits Temáticos" },
  { src: "/site-images/W2LnyI22e60Z.jpg", label: "Etiquetas Premium" },
  { src: "/site-images/Vti1VoDcr6i1.jpg", label: "Cartões de Agradecimento" },
  { src: "/site-images/eUEL19nlc1SC.jpg", label: "Embalagens Sofisticadas" },
  { src: "/site-images/WizhnwESFDLz.jpg", label: "Kits Personalizados" },
  { src: "/site-images/L75pl9qtbeFT.jpg", label: "Coleções Exclusivas" },
  { src: "/site-images/ZVRUn8TBmlHy.jpg", label: "Kits Decorativos" },
];

export const testimonials = [
  {
    name: "Camila Ribeiro",
    role: "Artesã • São Paulo/SP",
    stars: 5,
    text:
      "Meu Deus, mudou completamente meu ateliê! Comecei a vender kits inteiros com as tags e sacolinhas. Em duas semanas já paguei o valor do material e ainda sobrou pra investir em papel bom.",
  },
  {
    name: "Juliana Alves",
    role: "Confeiteira • Recife/PE",
    stars: 5,
    text:
      "As tags de agradecimento fizeram TODA a diferença. As clientes começaram a mandar foto pro Instagram, o boca a boca disparou e meu WhatsApp não para mais.",
  },
  {
    name: "Priscila Souza",
    role: "Laceira • Belo Horizonte/MG",
    stars: 5,
    text:
      "Eu perdia HORAS tentando criar arte no Canva do zero. Agora é só abrir, trocar o nome e imprimir. Consigo entregar 3x mais pedidos por semana.",
  },
  {
    name: "Renata Lima",
    role: "Artesã • Salvador/BA",
    stars: 5,
    text:
      "O bônus da precificação abriu meus olhos. Eu cobrava muito pouco! Aumentei o preço, apresentei melhor e as clientes elogiam e voltam sempre. Vale cada centavo.",
  },
  {
    name: "Aline Ferreira",
    role: "Empreendedora • Curitiba/PR",
    stars: 5,
    text:
      "Nunca imaginei que tags e adesivos bonitos fizessem tanta diferença na percepção do produto. Minhas encomendas dobraram em 30 dias.",
  },
  {
    name: "Tatiane Melo",
    role: "Ateliê Casa Doce • Fortaleza/CE",
    stars: 5,
    text:
      "Comprei achando que era só mais um pacote de artes. Que engano! É um acervo gigante, super organizado e tudo lindo. Meu ateliê ficou irreconhecível.",
  },
];

export const originalBonuses = [
  {
    n: "01",
    title: "PRECIFICAÇÃO LUCRATIVA",
    desc: "Descubra exatamente quanto cobrar e aumente seus lucros.",
    value: "R$27",
  },
  {
    n: "02",
    title: "COMBINAÇÃO DE CORES",
    desc: "Paletas prontas para deixar suas tags ainda mais bonitas.",
    value: "R$27",
  },
  {
    n: "03",
    title: "APRESENTAÇÃO LUCRATIVA",
    desc: "Aprenda a encantar suas clientes na entrega.",
    value: "R$27",
  },
  {
    n: "04",
    title: "CALENDÁRIO LUCRATIVO",
    desc: "Datas sazonais para vender durante todo o ano.",
    value: "R$27",
  },
  {
    n: "05",
    title: "CATÁLOGO PRONTO",
    desc: "Fotos e artes para divulgar imediatamente.",
    value: "R$27",
  },
];

export const extraBonuses = [
  {
    n: "06",
    title: "+500 FRASES PARA TAGS",
    desc: "Frases prontas para agradecimento, fidelização, datas comemorativas e vendas.",
    value: "R$37",
  },
  {
    n: "07",
    title: "KIT DE FONTES PREMIUM",
    desc: "Mais de 150 fontes lindas para deixar qualquer arte profissional.",
    value: "R$17",
  },
  {
    n: "08",
    title: "MOCKUPS PROFISSIONAIS",
    desc: "Mockups prontos para divulgar suas artes no Instagram, WhatsApp e Catálogo.",
    value: "R$47",
  },
  {
    n: "09",
    title: "MANUAL DO CANVA",
    desc: "Tutorial completo para editar qualquer arquivo em poucos minutos, mesmo sendo iniciante.",
    value: "R$27",
  },
  {
    n: "10",
    title: "PACOTE DE ELEMENTOS DECORATIVOS",
    desc: "Laços, flores, corações, molduras, ícones e ilustrações para personalizar as artes.",
    value: "R$17",
  },
  {
    n: "11",
    title: "KIT DE POSTS PARA INSTAGRAM",
    desc: "Mais de 100 artes prontas para divulgar seus produtos e conseguir clientes.",
    value: "R$19",
  },
  {
    n: "12",
    title: "ETIQUETAS PARA ENCOMENDAS",
    desc: "Modelos prontos: Frágil, Feito com Amor, Obrigada pela Compra, Não Amassar, Lacres e Etiquetas de envio.",
    value: "R$37",
  },
  {
    n: "13",
    title: "CHECKLIST DA ARTESÃ ORGANIZADA",
    desc: "Planilhas e checklists para controlar pedidos, clientes, estoque e entregas.",
    value: "R$17",
  },
  {
    n: "14",
    title: "KIT DE EMBALAGENS LUCRATIVAS",
    desc: "Ideias de montagem de kits, embalagens premium e formas de agregar valor ao produto.",
    value: "R$27",
  },
  {
    n: "15",
    title: 'GUIA "COMO VENDER TODOS OS DIAS PELO WHATSAPP"',
    desc: "Mensagens prontas, estratégias de divulgação e técnicas simples para conseguir encomendas diariamente.",
    value: "R$27",
  },
  {
    n: "16",
    title: "LISTA DE FORNECEDORES PREMIUM",
    desc: "Onde comprar fitas, pérolas, bicos de pato, embalagens e materiais com ótimo custo-benefício.",
    value: "R$37",
  },
  {
    n: "17",
    title: "CALCULADORA DE PRECIFICAÇÃO AUTOMÁTICA",
    desc: "Planilha pronta que calcula automaticamente o preço de venda e o lucro de cada laço.",
    value: "R$37",
  },
  {
    n: "18",
    title: "ATUALIZAÇÕES VITALÍCIAS",
    desc: "Todos os novos modelos, aulas e materiais adicionados futuramente serão liberados gratuitamente para você.",
    value: "R$47",
  },
];

export const faqs = [
  {
    q: "Como vou receber o material?",
    a: "Após a compra, você recebe acesso imediato pelo seu e-mail e também pode receber pelo WhatsApp. É só acessar e começar a usar na hora.",
  },
  {
    q: "Preciso ter experiência com Canva?",
    a: "Não. Os modelos são prontos e fáceis de editar. Além disso, você recebe um guia passo a passo ensinando exatamente como personalizar suas capas.",
  },
  {
    q: "Preciso de impressora?",
    a: "Não necessariamente. Você pode usar os arquivos digitalmente ou enviar para qualquer gráfica imprimir. Tudo já está pronto para facilitar.",
  },
  {
    q: "São quantos arquivos ao todo?",
    a: "Você recebe mais de 700 arquivos prontos e editáveis, além de todos os bônus liberados nesta página.",
  },
  {
    q: "Quais formas de pagamento são aceitas?",
    a: "Você pode pagar com cartão de crédito (parcelado em até 11x), PIX ou boleto, de forma simples e segura.",
  },
  {
    q: "Tem garantia?",
    a: "Sim. Você tem 15 dias de garantia incondicional. Se por qualquer motivo não gostar, é só pedir reembolso dentro desse prazo.",
  },
];

export const heroImage = "/site-images/cD37eHGy0BF9.png";
export const CHECKOUT_URL = "https://go.perfectpay.com.br/PPU38CQE452";
export const OFFER_ANCHOR = "#oferta";
export const CTA_TEXT = "GARANTIR MEU ACESSO AGORA";
export const CTA_CHECKOUT_TEXT = "QUERO GARANTIR MEU ACESSO AGORA COM DESCONTO";
